import loadable from '@loadable/component';

export const LandingPage = loadable(/* #__LOADABLE__ */ () => import('./LandingPage'));
